import axios from 'axios'
let apiHost = process.env.REACT_APP_HOST_ADMIN;
const response = (resp) => {
   return resp.data;
};
const instance = axios.create({
   baseURL: apiHost+'/api/client',
   timeout: 5000,
   withCredentials: true,
   crossdomain: true,
});
let get = url => instance.get(url).then(response);
let post = (url, data) => {
   let bodyFormData = new FormData();
   for (let key in data) {
      bodyFormData.append(key, data[key])
   }
   return instance.post(url, bodyFormData).then(response)
};

let projects = {
   list: () => get("/projects").then(response),
   get: (uuid) => get('/projects/'+uuid),
   show: (uuid) => post("/project", {uuid})
};
export default {
   projects
};

